import { ShoppingListIngredientDetail } from "@/clients/models/ShoppingListIngredientDetail";
import { IonSkeletonText } from "@ionic/react";
import { memo } from "react";
import EmptyShopList from "../empty-shop-list";
import ShoppingList from "../shopping-list";

interface ShopListContentProps {
  isLoading: boolean;
  error: Error | null;
  selectedIngredients: ShoppingListIngredientDetail[];
  tickedItems: Set<string>;
  handleToggleItem: (ingredientId: string) => () => void;
}

/**
 * Scrollable body of the shopping list modal.
 * Expands to fill all remaining vertical space between the tabs and the footer.
 */
export const ShopListContent = memo(function ShopListContent({
  isLoading,
  error,
  selectedIngredients,
  tickedItems,
  handleToggleItem,
}: ShopListContentProps) {
  return (
    <div className="no-scrollbar min-h-0 flex-1 overflow-y-auto px-4">
      {isLoading && (
        <div className="flex flex-col gap-3 pt-2">
          <IonSkeletonText animated className="h-12 rounded-xl" />
          <IonSkeletonText animated className="h-12 rounded-xl" />
          <IonSkeletonText animated className="h-12 rounded-xl" />
        </div>
      )}

      {error && !isLoading && (
        <div className="flex h-full items-center justify-center text-sm text-gray-500">
          {error.message}
        </div>
      )}

      {!isLoading && !error && selectedIngredients.length === 0 && <EmptyShopList />}

      {!isLoading && !error && selectedIngredients.length > 0 && (
        <ShoppingList
          selectedIngredients={selectedIngredients}
          tickedItems={tickedItems}
          handleToggleItem={handleToggleItem}
        />
      )}
    </div>
  );
});
